import React, { useContext } from "react"
import Img from "gatsby-image"
import { MDXRenderer } from "gatsby-plugin-mdx"

import ContentfulDataContext from "../context/contentful-data"

const AllBooks = props => {
  const { allContentfulBook } = useContext(ContentfulDataContext)

  const categories = allContentfulBook.edges.reduce(
    (acc, { node: { category } }) => {
      if (acc.indexOf(category) < 0) {
        acc.push(category)
      }

      return acc
    },
    []
  )

  if (!categories.length) {
    return ""
  }

  const booksByCategory = []
  for (const cat of categories) {
    booksByCategory.push({
      category: cat,
      five: [],
      others: [],
      notYetRead: [],
    })
  }

  const pushToCategory = book => {
    const catObj = booksByCategory.filter(cat => {
      return cat.category === book.category
    })[0]

    const rating = book.rating && +book.rating
    const cat =
      rating === 5
        ? catObj.five
        : rating < 5 && rating >= 1
        ? catObj.others
        : catObj.notYetRead

    book.rate = []
    if (rating) {
      for (let i = 0; i < 5; i++) {
        const star = i < rating ? "★" : "☆"
        book.rate.push(star)
      }
    }

    cat.push(book)
  }

  for (const { node } of allContentfulBook.edges) {
    pushToCategory(node)
  }

  const Book5Stars = ({ books }) => (
    <>
      {!books || !books.length ? (
        ""
      ) : (
        <>
          <section className="book-list">
            {books.map(book => (
              <article className="row" key={book.contentful_id}>
                <div className="cover">
                  <a
                    href={`/r/${book.slug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Img
                      fluid={book.coverImage.fluid}
                      alt={book.title}
                      title={book.title}
                      className="cover-image"
                    />
                    <span className="rating">{book.rate}</span>
                  </a>
                </div>
                <div className="intro">
                  <h4 className="title">{book.title}</h4>
                  {book.childContentfulMdx &&
                  book.childContentfulMdx.childMdx ? (
                    <MDXRenderer>
                      {book.childContentfulMdx.childMdx.body}
                    </MDXRenderer>
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: book.excerpt ? book.excerpt.excerpt : "",
                      }}
                    ></div>
                  )}
                </div>
              </article>
            ))}
          </section>
        </>
      )}
    </>
  )

  const BookOthers = ({ books }) => (
    <>
      {!books || !books.length ? (
        ""
      ) : (
        <section className="book-grid">
          {books.map(book => (
            <article className="cell" key={book.contentful_id}>
              <a
                href={`/r/${book.slug}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={book.coverImage.fluid}
                  alt={book.title}
                  title={book.title}
                  className="cover-image"
                />
                <span className="rating">{book.rate}</span>
              </a>
            </article>
          ))}
        </section>
      )}
    </>
  )

  const BooksNotYetRead = ({ category, books }) => (
    <>
      {!books || !books.length ? (
        ""
      ) : (
        <>
          <h4 id={category.toLowerCase().replace(/ /g, "-")}>
            {category} books I’ve yet to read
          </h4>
          <section className="book-grid">
            {books.map(book => (
              <article className="cell" key={book.contentful_id}>
                <a
                  href={`/r/${book.slug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Img
                    fluid={book.coverImage.fluid}
                    alt={book.title}
                    title={book.title}
                    className="cover-image"
                  />
                </a>
              </article>
            ))}
          </section>
        </>
      )}
    </>
  )

  return (
    <>
      {booksByCategory.map(cat => (
        <React.Fragment key={cat.category}>
          <h3 id={`books-on-${cat.category.toLowerCase().replace(/ /g, "-")}`}>
            Books on {cat.category.toLowerCase()}
          </h3>
          <Book5Stars books={cat.five} />
          <BookOthers books={cat.others} />
          <BooksNotYetRead category={cat.category} books={cat.notYetRead} />
        </React.Fragment>
      ))}
    </>
  )
}

export default AllBooks
